import {
  ADD_NEW_STAFF,
  ADD_STAFF_SUCCESS,
  ADD_STAFF_FAIL,
  GET_STAFF_DATA,
  GET_STAFF_DATA_SUCCESS,
  GET_STAFF_DATA_FAIL,
  UPDATE_STAFF,
  UPDATE_STAFF_SUCCESS,
  UPDATE_STAFF_FAIL,
  DELETE_STAFF,
  DELETE_STAFF_SUCCESS,
  DELETE_STAFF_FAIL,
  GET_STAFF_LIST,
  GET_STAFF_LIST_SUCCESS,
  GET_STAFF_LIST_FAIL,
  SEARCH_STAFF_INCOME_LIST,
  SEARCH_STAFF_INCOME_LIST_SUCCESS,
  SEARCH_STAFF_INCOME_LIST_FAIL,
  GET_STAFF_LEAVE_TYPE_LIST,
  GET_STAFF_LEAVE_TYPE_LIST_SUCCESS,
  GET_STAFF_LEAVE_TYPE_LIST_FAIL,
  ADD_STAFF_LEAVE_TYPE,
  ADD_STAFF_LEAVE_TYPE_SUCCESS,
  ADD_STAFF_LEAVE_TYPE_FAIL,
  UPDATE_STAFF_LEAVE_TYPE,
  UPDATE_STAFF_LEAVE_TYPE_SUCCESS,
  UPDATE_STAFF_LEAVE_TYPE_FAIL,
  DELETE_STAFF_LEAVE_TYPE,
  DELETE_STAFF_LEAVE_TYPE_SUCCESS,
  DELETE_STAFF_LEAVE_TYPE_FAIL,
  CREATE_STAFF_INCOME,
  CREATE_STAFF_INCOME_SUCCESS,
  CREATE_STAFF_INCOME_FAIL,
  GET_STAFF_INCOME_CATEGORY_ITEM_LIST,
  GET_STAFF_INCOME_CATEGORY_ITEM_LIST_SUCCESS,
  GET_STAFF_INCOME_CATEGORY_ITEM_LIST_FAIL,
  GET_STAFF_INCOME_CATEGORY_ITEM_DATA,
  GET_STAFF_INCOME_CATEGORY_ITEM_DATA_SUCCESS,
  GET_STAFF_INCOME_CATEGORY_ITEM_DATA_FAIL,
  CREATE_STAFF_INCOME_CATEGORY_ITEM,
  CREATE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS,
  CREATE_STAFF_INCOME_CATEGORY_ITEM_FAIL,
  UPDATE_STAFF_INCOME_CATEGORY_ITEM,
  UPDATE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS,
  UPDATE_STAFF_INCOME_CATEGORY_ITEM_FAIL,
  DELETE_STAFF_INCOME_CATEGORY_ITEM,
  DELETE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS,
  DELETE_STAFF_INCOME_CATEGORY_ITEM_FAIL,
  GET_STAFF_INCOME_LIST,
  GET_STAFF_INCOME_LIST_SUCCESS,
  GET_STAFF_INCOME_LIST_FAIL,
  GET_STAFF_INCOME_DATA,
  GET_STAFF_INCOME_DATA_SUCCESS,
  GET_STAFF_INCOME_DATA_FAIL,
  UPDATE_STAFF_INCOME,
  UPDATE_STAFF_INCOME_SUCCESS,
  UPDATE_STAFF_INCOME_FAIL,
  DELETE_STAFF_INCOME,
  DELETE_STAFF_INCOME_SUCCESS,
  DELETE_STAFF_INCOME_FAIL,
  GET_STAFF_LEAVE_LIST,
  GET_STAFF_LEAVE_LIST_SUCCESS,
  GET_STAFF_LEAVE_LIST_FAIL,
  GET_STAFF_LEAVE_DATA,
  GET_STAFF_LEAVE_DATA_SUCCESS,
  GET_STAFF_LEAVE_DATA_FAIL,
  UPDATE_STAFF_LEAVE,
  UPDATE_STAFF_LEAVE_SUCCESS,
  UPDATE_STAFF_LEAVE_FAIL,
  DELETE_STAFF_LEAVE,
  DELETE_STAFF_LEAVE_SUCCESS,
  DELETE_STAFF_LEAVE_FAIL,
  CREATE_STAFF_LEAVE,
  CREATE_STAFF_LEAVE_SUCCESS,
  CREATE_STAFF_LEAVE_FAIL,
  SEARCH_STAFF_LEAVE,
  SEARCH_STAFF_LEAVE_SUCCESS,
  SEARCH_STAFF_LEAVE_FAIL,
  GET_STAFF_LEAVE_ALLOWANCE_LIST,
  GET_STAFF_LEAVE_ALLOWANCE_LIST_SUCCESS,
  GET_STAFF_LEAVE_ALLOWANCE_LIST_FAIL,
  GET_STAFF_LEAVE_ALLOWANCE_DATA,
  GET_STAFF_LEAVE_ALLOWANCE_DATA_SUCCESS,
  GET_STAFF_LEAVE_ALLOWANCE_DATA_FAIL,
  UPDATE_STAFF_LEAVE_ALLOWANCE,
  UPDATE_STAFF_LEAVE_ALLOWANCE_SUCCESS,
  UPDATE_STAFF_LEAVE_ALLOWANCE_FAIL,
  DELETE_STAFF_LEAVE_ALLOWANCE,
  DELETE_STAFF_LEAVE_ALLOWANCE_SUCCESS,
  DELETE_STAFF_LEAVE_ALLOWANCE_FAIL,
  CREATE_STAFF_LEAVE_ALLOWANCE,
  CREATE_STAFF_LEAVE_ALLOWANCE_SUCCESS,
  CREATE_STAFF_LEAVE_ALLOWANCE_FAIL,
  SEARCH_STAFF_LEAVE_ALLOWANCE,
  SEARCH_STAFF_LEAVE_ALLOWANCE_SUCCESS,
  SEARCH_STAFF_LEAVE_ALLOWANCE_FAIL,
  SEARCH_STAFF,
  SEARCH_STAFF_SUCCESS,
  SEARCH_STAFF_FAIL,
  SEARCH_STAFF_MEMBERS,
  SEARCH_STAFF_MEMBERS_SUCCESS,
  SEARCH_STAFF_MEMBERS_FAIL,
  CREATE_STAFF_AND_USER,
  CREATE_STAFF_AND_USER_SUCCESS,
  CREATE_STAFF_AND_USER_FAIL,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST_SUCCESS,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST_FAIL,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA_SUCCESS,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA_FAIL,
  CREATE_ORGANISATION_DEPARTMENT_TO_STAFF,
  CREATE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS,
  CREATE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL,
  SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF,
  SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS,
  SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL,
  UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF,
  UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS,
  UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL,
  DELETE_ORGANISATION_DEPARTMENT_TO_STAFF,
  DELETE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS,
  DELETE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL,
  GET_ORGANISATION_DEPARTMENT_LIST,
  GET_ORGANISATION_DEPARTMENT_LIST_SUCCESS,
  GET_ORGANISATION_DEPARTMENT_LIST_FAIL,
  GET_ORGANISATION_DEPARTMENT_DATA,
  GET_ORGANISATION_DEPARTMENT_DATA_SUCCESS,
  GET_ORGANISATION_DEPARTMENT_DATA_FAIL,
  CREATE_ORGANISATION_DEPARTMENT,
  CREATE_ORGANISATION_DEPARTMENT_SUCCESS,
  CREATE_ORGANISATION_DEPARTMENT_FAIL,
  GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY,
  GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY_SUCCESS,
  GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY_FAIL,
  UPDATE_ORGANISATION_DEPARTMENT,
  UPDATE_ORGANISATION_DEPARTMENT_SUCCESS,
  UPDATE_ORGANISATION_DEPARTMENT_FAIL,
  DELETE_ORGANISATION_DEPARTMENT,
  DELETE_ORGANISATION_DEPARTMENT_SUCCESS,
  DELETE_ORGANISATION_DEPARTMENT_FAIL,
  GET_STAFF_TO_STAFF_MANAGER_LIST,
  GET_STAFF_TO_STAFF_MANAGER_LIST_SUCCESS,
  GET_STAFF_TO_STAFF_MANAGER_LIST_FAIL,
  GET_STAFF_TO_STAFF_MANAGER_DATA,
  GET_STAFF_TO_STAFF_MANAGER_DATA_SUCCESS,
  GET_STAFF_TO_STAFF_MANAGER_DATA_FAIL,
  CREATE_STAFF_TO_STAFF_MANAGER,
  CREATE_STAFF_TO_STAFF_MANAGER_SUCCESS,
  CREATE_STAFF_TO_STAFF_MANAGER_FAIL,
  UPDATE_STAFF_TO_STAFF_MANAGER,
  UPDATE_STAFF_TO_STAFF_MANAGER_SUCCESS,
  UPDATE_STAFF_TO_STAFF_MANAGER_FAIL,
  DELETE_STAFF_TO_STAFF_MANAGER,
  DELETE_STAFF_TO_STAFF_MANAGER_SUCCESS,
  DELETE_STAFF_TO_STAFF_MANAGER_FAIL,
  GET_STAFF_RECENT_ACTIVITY_LIST,
  GET_STAFF_RECENT_ACTIVITY_LIST_SUCCESS,
  GET_STAFF_RECENT_ACTIVITY_LIST_FAIL,
  STAFF_ACTIVITY_LOG_SEARCH,
  STAFF_ACTIVITY_LOG_SEARCH_SUCCESS,
  STAFF_ACTIVITY_LOG_SEARCH_FAILURE,
  SEARCH_STAFF_REAL_TIME,
  SEARCH_STAFF_REAL_TIME_SUCCESS,
  SEARCH_STAFF_REAL_TIME_FAIL,
  GET_STAFF_SKILL_SET_LIST,
  GET_STAFF_SKILL_SET_LIST_SUCCESS,
  GET_STAFF_SKILL_SET_LIST_FAIL,
  GET_STAFF_SKILL_SET_DATA,
  GET_STAFF_SKILL_SET_DATA_SUCCESS,
  GET_STAFF_SKILL_SET_DATA_FAIL,
  CREATE_STAFF_SKILL_SET,
  CREATE_STAFF_SKILL_SET_SUCCESS,
  CREATE_STAFF_SKILL_SET_FAIL,
  UPDATE_STAFF_SKILL_SET,
  UPDATE_STAFF_SKILL_SET_SUCCESS,
  UPDATE_STAFF_SKILL_SET_FAIL,
  DELETE_STAFF_SKILL_SET,
  DELETE_STAFF_SKILL_SET_SUCCESS,
  DELETE_STAFF_SKILL_SET_FAIL,
  GET_STAFF_TO_STAFF_SKILL_SET_LIST,
  GET_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS,
  GET_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL,
  GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST,
  GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS,
  GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL,
  GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST,
  GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS,
  GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL,
  GET_STAFF_TO_STAFF_SKILL_SET_DATA,
  GET_STAFF_TO_STAFF_SKILL_SET_DATA_SUCCESS,
  GET_STAFF_TO_STAFF_SKILL_SET_DATA_FAIL,
  CREATE_STAFF_TO_STAFF_SKILL_SET,
  CREATE_STAFF_TO_STAFF_SKILL_SET_SUCCESS,
  CREATE_STAFF_TO_STAFF_SKILL_SET_FAIL,
  UPDATE_STAFF_TO_STAFF_SKILL_SET,
  UPDATE_STAFF_TO_STAFF_SKILL_SET_SUCCESS,
  UPDATE_STAFF_TO_STAFF_SKILL_SET_FAIL,
  DELETE_STAFF_TO_STAFF_SKILL_SET,
  DELETE_STAFF_TO_STAFF_SKILL_SET_SUCCESS,
  DELETE_STAFF_TO_STAFF_SKILL_SET_FAIL,
  SEARCH_STAFF_TO_STAFF_SKILL_SET,
  SEARCH_STAFF_TO_STAFF_SKILL_SET_SUCCESS,
  SEARCH_STAFF_TO_STAFF_SKILL_SET_FAIL,
  SEARCH_STAFF_AVAILABILITY,
  SEARCH_STAFF_AVAILABILITY_SUCCESS,
  SEARCH_STAFF_AVAILABILITY_FAIL,
  SEARCH_STAFF_GPS_LOCATION_HISTORY,
  SEARCH_STAFF_GPS_LOCATION_HISTORY_SUCCESS,
  SEARCH_STAFF_GPS_LOCATION_HISTORY_FAIL,
  GET_STAFF_WORKING_SCHEDULE_RECORD_LIST,
  GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_SUCCESS,
  GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_FAIL,
  GET_STAFF_WORKING_SCHEDULE_RECORD_DATA,
  GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_SUCCESS,
  GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_FAIL,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD_FAIL,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD_FAIL,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD_FAIL,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_SUCCESS,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_FAIL,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_SUCCESS,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_FAIL,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL,
  GET_STAFF_WORKING_SCHEDULE_LIST,
  GET_STAFF_WORKING_SCHEDULE_LIST_SUCCESS,
  GET_STAFF_WORKING_SCHEDULE_LIST_FAIL,
  GET_STAFF_WORKING_SCHEDULE_DATA,
  GET_STAFF_WORKING_SCHEDULE_DATA_SUCCESS,
  GET_STAFF_WORKING_SCHEDULE_DATA_FAIL,
  CREATE_STAFF_WORKING_SCHEDULE,
  CREATE_STAFF_WORKING_SCHEDULE_SUCCESS,
  CREATE_STAFF_WORKING_SCHEDULE_FAIL,
  UPDATE_STAFF_WORKING_SCHEDULE,
  UPDATE_STAFF_WORKING_SCHEDULE_SUCCESS,
  UPDATE_STAFF_WORKING_SCHEDULE_FAIL,
  DELETE_STAFF_WORKING_SCHEDULE,
  DELETE_STAFF_WORKING_SCHEDULE_SUCCESS,
  DELETE_STAFF_WORKING_SCHEDULE_FAIL,
  SEARCH_STAFF_WORKING_SCHEDULE,
  SEARCH_STAFF_WORKING_SCHEDULE_SUCCESS,
  SEARCH_STAFF_WORKING_SCHEDULE_FAIL,
  SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE,
  SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE_SUCCESS,
  SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE_FAIL,
  CALCULATE_STAFF_WORKING_SCHEDULE,
  CALCULATE_STAFF_WORKING_SCHEDULE_SUCCESS,
  CALCULATE_STAFF_WORKING_SCHEDULE_FAIL,
} from "./actionType";

const INIT_STATE = {
  error: "",
  updateSuccess: [],
  loadingUpdateStaff: false,
  deleteSuccess: [],
  loadingDeleteStaff: false,
  addSuccess: [],
  loadingAddStaffList: false,
  singleStaffData: [],
  loadingGetStaffData: false,
  staffList: [],
  loadingGetStaffList: false,
  staffIncomeList: [],
  loadingStaffIncomeList: false,
  staffLeaveTypeList: [],
  loadingStaffLeaveTypeList: false,
  addStaffLeaveTypeSuccess: [],
  loadingAddStaffLeaveType: false,
  updateStaffLeaveTypeSuccess: [],
  loadingUpdateStaffLeaveType: false,
  deleteStaffLeaveTypeSuccess: [],
  loadingDeleteStaffLeaveType: false,
  createStaffIncomeSuccess: [],
  loadingCreateStaffIncome: false,
  staffIncomeCategoryItemList: [],
  loadingStaffIncomeCategoryItemList: false,
  staffIncomeCategoryItemData: [],
  loadingStaffIncomeCategoryItemData: false,
  createStaffIncomeCategoryItemSuccess: [],
  loadingCreateStaffIncomeCategoryItem: false,
  updateStaffIncomeCategoryItemSuccess: [],
  loadingUpdateStaffIncomeCategoryItem: false,
  deleteStaffIncomeCategoryItemSuccess: [],
  loadingDeleteStaffIncomeCategoryItem: false,
  getAllStaffIncomeList: [],
  loadingGetAllStaffIncomeList: false,
  singleStaffIncomeData: [],
  loadingGetStaffIncomeData: false,
  updateStaffIncomeSuccess: [],
  loadingUpdateStaffIncome: false,
  deleteStaffIncomeSuccess: [],
  loadingDeleteStaffIncome: false,

  // Staff Leave
  staffLeaveList: [],
  loadingStaffLeaveList: false,
  singleStaffLeaveData: [],
  loadingGetStaffLeaveData: false,
  updateStaffLeaveSuccess: [],
  loadingUpdateStaffLeave: false,
  deleteStaffLeaveSuccess: [],
  loadingDeleteStaffLeave: false,
  addStaffLeaveSuccess: [],
  loadingAddStaffLeave: false,
  searchStaffLeaveSuccess: [],
  loadingSearchStaffLeave: false,
  // Staff Leave Allowance
  staffLeaveAllowanceList: [],
  loadingStaffLeaveAllowanceList: false,
  singleStaffLeaveAllowanceData: [],
  loadingGetStaffLeaveAllowanceData: false,
  updateStaffLeaveAllowanceSuccess: [],
  loadingUpdateStaffLeaveAllowance: false,
  deleteStaffLeaveAllowanceSuccess: [],
  loadingDeleteStaffLeaveAllowance: false,
  addStaffLeaveAllowanceSuccess: [],
  loadingAddStaffLeaveAllowance: false,
  searchStaffLeaveAllowanceSuccess: [],
  loadingSearchStaffLeaveAllowance: false,
  searchStaffSuccess: [],
  loadingSearchStaff: false,

  // Staff Members
  searchStaffMembersSuccess: [],
  loadingSearchStaffMembers: false,

  // Staff and User
  createStaffAndUserSuccess: [],
  loadingCreateStaffAndUser: false,

  // Organisation Department to Staff
  organisationDepartmentToStaffList: [],
  loadingOrganisationDepartmentToStaffList: false,
  singleOrganisationDepartmentToStaffData: [],
  loadingGetOrganisationDepartmentToStaffData: false,
  createOrganisationDepartmentToStaffSuccess: [],
  loadingCreateOrganisationDepartmentToStaff: false,
  searchOrganisationDepartmentToStaffSuccess: [],
  loadingSearchOrganisationDepartmentToStaff: false,
  updateOrganisationDepartmentToStaffSuccess: [],
  loadingUpdateOrganisationDepartmentToStaff: false,
  deleteOrganisationDepartmentToStaffSuccess: [],
  loadingDeleteOrganisationDepartmentToStaff: false,
  // Organisation Department
  organisationDepartmentList: [],
  loadingOrganisationDepartmentList: false,
  singleOrganisationDepartmentData: [],
  loadingGetOrganisationDepartmentData: false,
  createOrganisationDepartmentSuccess: [],
  loadingCreateOrganisationDepartment: false,
  organisationDepartmentHierarchyEnquiry: [],
  loadingOrganisationDepartmentHierarchyEnquiry: false,
  updateOrganisationDepartmentSuccess: [],
  loadingUpdateOrganisationDepartment: false,
  deleteOrganisationDepartmentSuccess: [],
  loadingDeleteOrganisationDepartment: false,
  // Staff to Staff Manager
  staffToStaffManagerList: [],
  loadingStaffToStaffManagerList: false,
  singleStaffToStaffManagerData: [],
  loadingGetStaffToStaffManagerData: false,
  createStaffToStaffManagerSuccess: [],
  loadingCreateStaffToStaffManager: false,
  updateStaffToStaffManagerSuccess: [],
  loadingUpdateStaffToStaffManager: false,
  deleteStaffToStaffManagerSuccess: [],
  loadingDeleteStaffToStaffManager: false,

  //   GET_STAFF_SKILL_SET_LIST,
  gettingStaffSkillSetList: [],
  loadingGetStaffSkillSetList: false,

  //   GET_STAFF_SKILL_SET_DATA,
  gettingStaffSkillSetData: [],
  loadingGetStaffSkillSetData: false,
  //   CREATE_STAFF_SKILL_SET,
  createStaffSkillSetSuccess: [],
  loadingCreateStaffSkillSet: false,
  //   UPDATE_STAFF_SKILL_SET,
  updateStaffSkillSetSuccess: [],
  loadingUpdateStaffSkillSet: false,
  //   DELETE_STAFF_SKILL_SET,
  deleteStaffSkillSetSuccess: [],
  loadingDeleteStaffSkillSet: false,
  //   GET_STAFF_TO_STAFF_SKILL_SET_LIST,
  staffToStaffSkillSetList: [],
  loadingStaffToStaffSkillSetList: false,
  //   GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST,
  activeStaffToStaffSkillSetList: [],
  loadingActiveStaffToStaffSkillSetList: false,
  //   GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST,
  expiredStaffToStaffSkillSetList: [],
  loadingExpiredStaffToStaffSkillSetList: false,
  //   GET_STAFF_TO_STAFF_SKILL_SET_DATA,
  singleStaffToStaffSkillSetData: [],
  loadingGetStaffToStaffSkillSetData: false,
  //   CREATE_STAFF_TO_STAFF_SKILL_SET,
  createStaffToStaffSkillSetSuccess: [],
  loadingCreateStaffToStaffSkillSet: false,
  //   UPDATE_STAFF_TO_STAFF_SKILL_SET,
  updateStaffToStaffSkillSetSuccess: [],
  loadingUpdateStaffToStaffSkillSet: false,
  //   DELETE_STAFF_TO_STAFF_SKILL_SET,
  deleteStaffToStaffSkillSetSuccess: [],
  loadingDeleteStaffToStaffSkillSet: false,
  //   SEARCH_STAFF_TO_STAFF_SKILL_SET,
  searchStaffToStaffSkillSetSuccess: [],
  loadingSearchStaffToStaffSkillSet: false,
  //   SEARCH_STAFF_AVAILABILITY,
  searchStaffAvailabilitySuccess: [],
  loadingSearchStaffAvailability: false,
  //SEARCH_STAFF_GPS_LOCATION_HISTORY
  searchStaffGpsLocationHistorySuccess: [],
  loadingSearchStaffGpsLocationHistory: false,

  staffWorkingScheduleRecordList: [],
  loadingStaffWorkingScheduleRecordList: false,
  singleStaffWorkingScheduleRecordData: [],
  loadingGetStaffWorkingScheduleRecordData: false,
  createStaffWorkingScheduleRecordSuccess: [],
  loadingCreateStaffWorkingScheduleRecord: false,
  updateStaffWorkingScheduleRecordSuccess: [],
  loadingUpdateStaffWorkingScheduleRecord: false,
  deleteStaffWorkingScheduleRecordSuccess: [],
  loadingDeleteStaffWorkingScheduleRecord: false,

  staffWorkingScheduleRecordAdjustmentList: [],
  loadingStaffWorkingScheduleRecordAdjustmentList: false,
  singleStaffWorkingScheduleRecordAdjustmentData: [],
  loadingGetStaffWorkingScheduleRecordAdjustmentData: false,
  createStaffWorkingScheduleRecordAdjustmentSuccess: [],
  loadingCreateStaffWorkingScheduleRecordAdjustment: false,
  updateStaffWorkingScheduleRecordAdjustmentSuccess: [],
  loadingUpdateStaffWorkingScheduleRecordAdjustment: false,
  deleteStaffWorkingScheduleRecordAdjustmentSuccess: [],
  loadingDeleteStaffWorkingScheduleRecordAdjustment: false,

  staffWorkingScheduleList: [],
  loadingStaffWorkingScheduleList: false,
  singleStaffWorkingScheduleData: [],
  loadingGetStaffWorkingScheduleData: false,
  createStaffWorkingScheduleSuccess: [],
  loadingCreateStaffWorkingSchedule: false,
  updateStaffWorkingScheduleSuccess: [],
  loadingUpdateStaffWorkingSchedule: false,
  deleteStaffWorkingScheduleSuccess: [],
  loadingDeleteStaffWorkingSchedule: false,

  //SEARCH_STAFF_WORKING_SCHEDULE
  searchStaffWorkingScheduleSuccess: [],
  loadingSearchStaffWorkingSchedule: false,

  //SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE (isolated channel)
  searchStaffWorkingScheduleForCloneSuccess: [],
  loadingSearchStaffWorkingScheduleForClone: false,

  //CALCULATE_STAFF_WORKING_SCHEDULE
  calculateStaffWorkingScheduleSuccess: [],
  loadingCalculateStaffWorkingSchedule: false,
};

const Staff = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_NEW_STAFF:
      return {
        ...state,
        loadingAddStaff: true,
      };
    case ADD_STAFF_SUCCESS:
      return {
        ...state,
        loadingAddStaff: false,
        addSuccess: action.payload,
      };
    case ADD_STAFF_FAIL:
      return {
        ...state,
        loadingAddStaff: false,
        error: action.payload,
      };
    case GET_STAFF_DATA:
      return {
        ...state,
        loadingGetStaffData: true,
      };
    case GET_STAFF_DATA_SUCCESS:
      return {
        ...state,
        loadingGetStaffData: false,
        singleStaffData: action.payload,
      };
    case GET_STAFF_DATA_FAIL:
      return {
        ...state,
        loadingGetStaffData: false,
        error: action.payload,
      };
    case UPDATE_STAFF:
      return {
        ...state,
        loadingUpdateStaff: true,
      };
    case UPDATE_STAFF_SUCCESS:
      return {
        ...state,
        loadingUpdateStaff: false,
        updateSuccess: action.payload,
      };
    case UPDATE_STAFF_FAIL:
      return {
        ...state,
        loadingUpdateStaff: false,
        error: action.payload,
      };
    case DELETE_STAFF:
      return {
        ...state,
        loadingDeleteStaff: true,
      };
    case DELETE_STAFF_SUCCESS:
      return {
        ...state,
        loadingDeleteStaff: false,
        deleteSuccess: action.payload,
      };
    case DELETE_STAFF_FAIL:
      return {
        ...state,
        loadingDeleteStaff: false,
        error: action.payload,
      };
    case GET_STAFF_LIST:
      return {
        ...state,
        loadingGetStaffList: true,
      };
    case GET_STAFF_LIST_SUCCESS:
      return {
        ...state,
        loadingGetStaffList: false,
        staffList: action.payload,
      };
    case GET_STAFF_LIST_FAIL:
      return {
        ...state,
        loadingGetStaffList: false,
        error: action.payload,
      };
    case SEARCH_STAFF_INCOME_LIST:
      return {
        ...state,
        loadingStaffIncomeList: true,
      };
    case SEARCH_STAFF_INCOME_LIST_SUCCESS:
      return {
        ...state,
        loadingStaffIncomeList: false,
        staffIncomeList: action.payload,
      };
    case SEARCH_STAFF_INCOME_LIST_FAIL:
      return {
        ...state,
        loadingStaffIncomeList: false,
        error: action.payload,
      };
    case GET_STAFF_LEAVE_TYPE_LIST:
      return {
        ...state,
        loadingStaffLeaveTypeList: true,
      };
    case GET_STAFF_LEAVE_TYPE_LIST_SUCCESS:
      return {
        ...state,
        loadingStaffLeaveTypeList: false,
        staffLeaveTypeList: action.payload,
      };
    case GET_STAFF_LEAVE_TYPE_LIST_FAIL:
      return {
        ...state,
        loadingStaffLeaveTypeList: false,
        error: action.payload,
      };
    case ADD_STAFF_LEAVE_TYPE:
      return {
        ...state,
        loadingAddStaffLeaveType: true,
      };
    case ADD_STAFF_LEAVE_TYPE_SUCCESS:
      return {
        ...state,
        loadingAddStaffLeaveType: false,
        addStaffLeaveTypeSuccess: action.payload,
      };
    case ADD_STAFF_LEAVE_TYPE_FAIL:
      return {
        ...state,
        loadingAddStaffLeaveType: false,
        error: action.payload,
      };
    case UPDATE_STAFF_LEAVE_TYPE:
      return {
        ...state,
        loadingUpdateStaffLeaveType: true,
      };
    case UPDATE_STAFF_LEAVE_TYPE_SUCCESS:
      return {
        ...state,
        loadingUpdateStaffLeaveType: false,
        updateStaffLeaveTypeSuccess: action.payload,
      };
    case UPDATE_STAFF_LEAVE_TYPE_FAIL:
      return {
        ...state,
        loadingUpdateStaffLeaveType: false,
        error: action.payload,
      };
    case DELETE_STAFF_LEAVE_TYPE:
      return {
        ...state,
        loadingDeleteStaffLeaveType: true,
      };
    case DELETE_STAFF_LEAVE_TYPE_SUCCESS:
      return {
        ...state,
        loadingDeleteStaffLeaveType: false,
        deleteStaffLeaveTypeSuccess: action.payload,
      };
    case DELETE_STAFF_LEAVE_TYPE_FAIL:
      return {
        ...state,
        loadingDeleteStaffLeaveType: false,
        error: action.payload,
      };
    case CREATE_STAFF_INCOME:
      return { ...state, loadingCreateStaffIncome: true };
    case CREATE_STAFF_INCOME_SUCCESS:
      return {
        ...state,
        loadingCreateStaffIncome: false,
        createStaffIncomeSuccess: action.payload,
      };
    case CREATE_STAFF_INCOME_FAIL:
      return {
        ...state,
        loadingCreateStaffIncome: false,
        error: action.payload,
      };
    case GET_STAFF_INCOME_CATEGORY_ITEM_LIST:
      return { ...state, loadingStaffIncomeCategoryItemList: true };
    case GET_STAFF_INCOME_CATEGORY_ITEM_LIST_SUCCESS:
      return {
        ...state,
        loadingStaffIncomeCategoryItemList: false,
        staffIncomeCategoryItemList: action.payload,
      };
    case GET_STAFF_INCOME_CATEGORY_ITEM_LIST_FAIL:
      return {
        ...state,
        loadingStaffIncomeCategoryItemList: false,
        error: action.payload,
      };
    case GET_STAFF_INCOME_CATEGORY_ITEM_DATA:
      return { ...state, loadingStaffIncomeCategoryItemData: true };
    case GET_STAFF_INCOME_CATEGORY_ITEM_DATA_SUCCESS:
      return {
        ...state,
        loadingStaffIncomeCategoryItemData: false,
        staffIncomeCategoryItemData: action.payload,
      };
    case GET_STAFF_INCOME_CATEGORY_ITEM_DATA_FAIL:
      return {
        ...state,
        loadingStaffIncomeCategoryItemData: false,
        error: action.payload,
      };
    case CREATE_STAFF_INCOME_CATEGORY_ITEM:
      return { ...state, loadingCreateStaffIncomeCategoryItem: true };
    case CREATE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS:
      return {
        ...state,
        loadingCreateStaffIncomeCategoryItem: false,
        createStaffIncomeCategoryItemSuccess: action.payload,
      };
    case CREATE_STAFF_INCOME_CATEGORY_ITEM_FAIL:
      return {
        ...state,
        loadingCreateStaffIncomeCategoryItem: false,
        error: action.payload,
      };
    case UPDATE_STAFF_INCOME_CATEGORY_ITEM:
      return { ...state, loadingUpdateStaffIncomeCategoryItem: true };
    case UPDATE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS:
      return {
        ...state,
        loadingUpdateStaffIncomeCategoryItem: false,
        updateStaffIncomeCategoryItemSuccess: action.payload,
      };
    case UPDATE_STAFF_INCOME_CATEGORY_ITEM_FAIL:
      return {
        ...state,
        loadingUpdateStaffIncomeCategoryItem: false,
        error: action.payload,
      };
    case DELETE_STAFF_INCOME_CATEGORY_ITEM:
      return { ...state, loadingDeleteStaffIncomeCategoryItem: true };
    case DELETE_STAFF_INCOME_CATEGORY_ITEM_SUCCESS:
      return {
        ...state,
        loadingDeleteStaffIncomeCategoryItem: false,
        deleteStaffIncomeCategoryItemSuccess: action.payload,
      };
    case DELETE_STAFF_INCOME_CATEGORY_ITEM_FAIL:
      return {
        ...state,
        loadingDeleteStaffIncomeCategoryItem: false,
        error: action.payload,
      };
    case GET_STAFF_INCOME_LIST:
      return { ...state, loadingGetAllStaffIncomeList: true };
    case GET_STAFF_INCOME_LIST_SUCCESS:
      return {
        ...state,
        loadingGetAllStaffIncomeList: false,
        getAllStaffIncomeList: action.payload,
      };
    case GET_STAFF_INCOME_LIST_FAIL:
      return {
        ...state,
        loadingGetAllStaffIncomeList: false,
        error: action.payload,
      };
    case GET_STAFF_INCOME_DATA:
      return { ...state, loadingGetStaffIncomeData: true };
    case GET_STAFF_INCOME_DATA_SUCCESS:
      return {
        ...state,
        loadingGetStaffIncomeData: false,
        singleStaffIncomeData: action.payload,
      };
    case GET_STAFF_INCOME_DATA_FAIL:
      return {
        ...state,
        loadingGetStaffIncomeData: false,
        error: action.payload,
      };
    case UPDATE_STAFF_INCOME:
      return { ...state, loadingUpdateStaffIncome: true };
    case UPDATE_STAFF_INCOME_SUCCESS:
      return {
        ...state,
        loadingUpdateStaffIncome: false,
        updateStaffIncomeSuccess: action.payload,
      };
    case UPDATE_STAFF_INCOME_FAIL:
      return {
        ...state,
        loadingUpdateStaffIncome: false,
        error: action.payload,
      };
    case DELETE_STAFF_INCOME:
      return { ...state, loadingDeleteStaffIncome: true };
    case DELETE_STAFF_INCOME_SUCCESS:
      return {
        ...state,
        loadingDeleteStaffIncome: false,
        deleteStaffIncomeSuccess: action.payload,
      };
    case DELETE_STAFF_INCOME_FAIL:
      return {
        ...state,
        loadingDeleteStaffIncome: false,
        error: action.payload,
      };
    // Staff Leave
    case GET_STAFF_LEAVE_LIST:
      return { ...state, loadingStaffLeaveList: true };
    case GET_STAFF_LEAVE_LIST_SUCCESS:
      return {
        ...state,
        loadingStaffLeaveList: false,
        staffLeaveList: action.payload,
      };
    case GET_STAFF_LEAVE_LIST_FAIL:
      return {
        ...state,
        loadingStaffLeaveList: false,
        error: action.payload,
      };
    case GET_STAFF_LEAVE_DATA:
      return { ...state, loadingGetStaffLeaveData: true };
    case GET_STAFF_LEAVE_DATA_SUCCESS:
      return {
        ...state,
        loadingGetStaffLeaveData: false,
        singleStaffLeaveData: action.payload,
      };
    case GET_STAFF_LEAVE_DATA_FAIL:
      return {
        ...state,
        loadingGetStaffLeaveData: false,
        error: action.payload,
      };
    case UPDATE_STAFF_LEAVE:
      return { ...state, loadingUpdateStaffLeave: true };
    case UPDATE_STAFF_LEAVE_SUCCESS:
      return {
        ...state,
        loadingUpdateStaffLeave: false,
        updateStaffLeaveSuccess: action.payload,
      };
    case UPDATE_STAFF_LEAVE_FAIL:
      return {
        ...state,
        loadingUpdateStaffLeave: false,
        error: action.payload,
      };
    case DELETE_STAFF_LEAVE:
      return { ...state, loadingDeleteStaffLeave: true };
    case DELETE_STAFF_LEAVE_SUCCESS:
      return {
        ...state,
        loadingDeleteStaffLeave: false,
        deleteStaffLeaveSuccess: action.payload,
      };
    case DELETE_STAFF_LEAVE_FAIL:
      return {
        ...state,
        loadingDeleteStaffLeave: false,
        error: action.payload,
      };
    case CREATE_STAFF_LEAVE:
      return { ...state, loadingAddStaffLeave: true };
    case CREATE_STAFF_LEAVE_SUCCESS:
      return {
        ...state,
        loadingAddStaffLeave: false,
        addStaffLeaveSuccess: action.payload,
      };
    case CREATE_STAFF_LEAVE_FAIL:
      return {
        ...state,
        loadingAddStaffLeave: false,
        error: action.payload,
      };
    case SEARCH_STAFF_LEAVE:
      return { ...state, loadingSearchStaffLeave: true };
    case SEARCH_STAFF_LEAVE_SUCCESS:
      return {
        ...state,
        loadingSearchStaffLeave: false,
        searchStaffLeaveSuccess: action.payload,
      };
    case SEARCH_STAFF_LEAVE_FAIL:
      return {
        ...state,
        loadingSearchStaffLeave: false,
        error: action.payload,
      };
    // Staff Leave Allowance
    case GET_STAFF_LEAVE_ALLOWANCE_LIST:
      return { ...state, loadingStaffLeaveAllowanceList: true };
    case GET_STAFF_LEAVE_ALLOWANCE_LIST_SUCCESS:
      return {
        ...state,
        loadingStaffLeaveAllowanceList: false,
        staffLeaveAllowanceList: action.payload,
      };
    case GET_STAFF_LEAVE_ALLOWANCE_LIST_FAIL:
      return {
        ...state,
        loadingStaffLeaveAllowanceList: false,
        error: action.payload,
      };
    case GET_STAFF_LEAVE_ALLOWANCE_DATA:
      return { ...state, loadingGetStaffLeaveAllowanceData: true };
    case GET_STAFF_LEAVE_ALLOWANCE_DATA_SUCCESS:
      return {
        ...state,
        loadingGetStaffLeaveAllowanceData: false,
        singleStaffLeaveAllowanceData: action.payload,
      };
    case GET_STAFF_LEAVE_ALLOWANCE_DATA_FAIL:
      return {
        ...state,
        loadingGetStaffLeaveAllowanceData: false,
        error: action.payload,
      };
    case UPDATE_STAFF_LEAVE_ALLOWANCE:
      return { ...state, loadingUpdateStaffLeaveAllowance: true };
    case UPDATE_STAFF_LEAVE_ALLOWANCE_SUCCESS:
      return {
        ...state,
        loadingUpdateStaffLeaveAllowance: false,
        updateStaffLeaveAllowanceSuccess: action.payload,
      };
    case UPDATE_STAFF_LEAVE_ALLOWANCE_FAIL:
      return {
        ...state,
        loadingUpdateStaffLeaveAllowance: false,
        error: action.payload,
      };
    case DELETE_STAFF_LEAVE_ALLOWANCE:
      return { ...state, loadingDeleteStaffLeaveAllowance: true };
    case DELETE_STAFF_LEAVE_ALLOWANCE_SUCCESS:
      return {
        ...state,
        loadingDeleteStaffLeaveAllowance: false,
        deleteStaffLeaveAllowanceSuccess: action.payload,
      };
    case DELETE_STAFF_LEAVE_ALLOWANCE_FAIL:
      return {
        ...state,
        loadingDeleteStaffLeaveAllowance: false,
        error: action.payload,
      };
    case CREATE_STAFF_LEAVE_ALLOWANCE:
      return { ...state, loadingAddStaffLeaveAllowance: true };
    case CREATE_STAFF_LEAVE_ALLOWANCE_SUCCESS:
      return {
        ...state,
        loadingAddStaffLeaveAllowance: false,
        addStaffLeaveAllowanceSuccess: action.payload,
      };
    case CREATE_STAFF_LEAVE_ALLOWANCE_FAIL:
      return {
        ...state,
        loadingAddStaffLeaveAllowance: false,
        error: action.payload,
      };
    case SEARCH_STAFF_LEAVE_ALLOWANCE:
      return { ...state, loadingSearchStaffLeaveAllowance: true };
    case SEARCH_STAFF_LEAVE_ALLOWANCE_SUCCESS:
      return {
        ...state,
        loadingSearchStaffLeaveAllowance: false,
        searchStaffLeaveAllowanceSuccess: action.payload,
      };
    case SEARCH_STAFF_LEAVE_ALLOWANCE_FAIL:
      return {
        ...state,
        loadingSearchStaffLeaveAllowance: false,
        error: action.payload,
      };
    case SEARCH_STAFF:
      return { ...state, loadingSearchStaff: true };
    case SEARCH_STAFF_SUCCESS:
      return {
        ...state,
        loadingSearchStaff: false,
        searchStaffSuccess: action.payload,
      };
    case SEARCH_STAFF_FAIL:
      return {
        ...state,
        loadingSearchStaff: false,
        error: action.payload,
      };
    case SEARCH_STAFF_MEMBERS:
      return { ...state, loadingSearchStaffMembers: true };
    case SEARCH_STAFF_MEMBERS_SUCCESS:
      return {
        ...state,
        loadingSearchStaffMembers: false,
        searchStaffMembersSuccess: action.payload,
      };
    case SEARCH_STAFF_MEMBERS_FAIL:
      return {
        ...state,
        loadingSearchStaffMembers: false,
        error: action.payload,
      };
    case CREATE_STAFF_AND_USER:
      return { ...state, loadingCreateStaffAndUser: true };
    case CREATE_STAFF_AND_USER_SUCCESS:
      return {
        ...state,
        loadingCreateStaffAndUser: false,
        createStaffAndUserSuccess: action.payload,
      };
    case CREATE_STAFF_AND_USER_FAIL:
      return {
        ...state,
        loadingCreateStaffAndUser: false,
        error: action.payload,
      };
    case GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST:
      return { ...state, loadingOrganisationDepartmentToStaffList: true };
    case GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST_SUCCESS:
      return {
        ...state,
        loadingOrganisationDepartmentToStaffList: false,
        organisationDepartmentToStaffList: action.payload,
      };
    case GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST_FAIL:
      return {
        ...state,
        loadingOrganisationDepartmentToStaffList: false,
        error: action.payload,
      };
    case GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA:
      return { ...state, loadingGetOrganisationDepartmentToStaffData: true };
    case GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA_SUCCESS:
      return {
        ...state,
        loadingGetOrganisationDepartmentToStaffData: false,
        singleOrganisationDepartmentToStaffData: action.payload,
      };
    case GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA_FAIL:
      return {
        ...state,
        loadingGetOrganisationDepartmentToStaffData: false,
        error: action.payload,
      };
    case CREATE_ORGANISATION_DEPARTMENT_TO_STAFF:
      return { ...state, loadingCreateOrganisationDepartmentToStaff: true };
    case CREATE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS:
      return {
        ...state,
        loadingCreateOrganisationDepartmentToStaff: false,
        createOrganisationDepartmentToStaffSuccess: action.payload,
      };
    case CREATE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL:
      return {
        ...state,
        loadingCreateOrganisationDepartmentToStaff: false,
        error: action.payload,
      };
    case SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF:
      return { ...state, loadingSearchOrganisationDepartmentToStaff: true };
    case SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS:
      return {
        ...state,
        loadingSearchOrganisationDepartmentToStaff: false,
        searchOrganisationDepartmentToStaffSuccess: action.payload,
      };
    case SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL:
      return {
        ...state,
        loadingSearchOrganisationDepartmentToStaff: false,
        error: action.payload,
      };
    case UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF:
      return { ...state, loadingUpdateOrganisationDepartmentToStaff: true };
    case UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS:
      return {
        ...state,
        loadingUpdateOrganisationDepartmentToStaff: false,
        updateOrganisationDepartmentToStaffSuccess: action.payload,
      };
    case UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL:
      return {
        ...state,
        loadingUpdateOrganisationDepartmentToStaff: false,
        error: action.payload,
      };
    case DELETE_ORGANISATION_DEPARTMENT_TO_STAFF:
      return { ...state, loadingDeleteOrganisationDepartmentToStaff: true };
    case DELETE_ORGANISATION_DEPARTMENT_TO_STAFF_SUCCESS:
      return {
        ...state,
        loadingDeleteOrganisationDepartmentToStaff: false,
        deleteOrganisationDepartmentToStaffSuccess: action.payload,
      };
    case DELETE_ORGANISATION_DEPARTMENT_TO_STAFF_FAIL:
      return {
        ...state,
        loadingDeleteOrganisationDepartmentToStaff: false,
        error: action.payload,
      };
    case GET_ORGANISATION_DEPARTMENT_LIST:
      return { ...state, loadingOrganisationDepartmentList: true };
    case GET_ORGANISATION_DEPARTMENT_LIST_SUCCESS:
      return {
        ...state,
        loadingOrganisationDepartmentList: false,
        organisationDepartmentList: action.payload,
      };
    case GET_ORGANISATION_DEPARTMENT_LIST_FAIL:
      return {
        ...state,
        loadingOrganisationDepartmentList: false,
        error: action.payload,
      };
    case GET_ORGANISATION_DEPARTMENT_DATA:
      return { ...state, loadingGetOrganisationDepartmentData: true };
    case GET_ORGANISATION_DEPARTMENT_DATA_SUCCESS:
      return {
        ...state,
        loadingGetOrganisationDepartmentData: false,
        singleOrganisationDepartmentData: action.payload,
      };
    case GET_ORGANISATION_DEPARTMENT_DATA_FAIL:
      return {
        ...state,
        loadingGetOrganisationDepartmentData: false,
        error: action.payload,
      };
    case CREATE_ORGANISATION_DEPARTMENT:
      return { ...state, loadingCreateOrganisationDepartment: true };
    case CREATE_ORGANISATION_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loadingCreateOrganisationDepartment: false,
        createOrganisationDepartmentSuccess: action.payload,
      };
    case CREATE_ORGANISATION_DEPARTMENT_FAIL:
      return {
        ...state,
        loadingCreateOrganisationDepartment: false,
        error: action.payload,
      };
    case GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY:
      return { ...state, loadingOrganisationDepartmentHierarchyEnquiry: true };
    case GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY_SUCCESS:
      return {
        ...state,
        loadingOrganisationDepartmentHierarchyEnquiry: false,
        organisationDepartmentHierarchyEnquiry: action.payload,
      };
    case GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY_FAIL:
      return {
        ...state,
        loadingOrganisationDepartmentHierarchyEnquiry: false,
        error: action.payload,
      };
    case UPDATE_ORGANISATION_DEPARTMENT:
      return { ...state, loadingUpdateOrganisationDepartment: true };
    case UPDATE_ORGANISATION_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loadingUpdateOrganisationDepartment: false,
        updateOrganisationDepartmentSuccess: action.payload,
      };
    case UPDATE_ORGANISATION_DEPARTMENT_FAIL:
      return {
        ...state,
        loadingUpdateOrganisationDepartment: false,
        error: action.payload,
      };
    case DELETE_ORGANISATION_DEPARTMENT:
      return { ...state, loadingDeleteOrganisationDepartment: true };
    case DELETE_ORGANISATION_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loadingDeleteOrganisationDepartment: false,
        deleteOrganisationDepartmentSuccess: action.payload,
      };
    case DELETE_ORGANISATION_DEPARTMENT_FAIL:
      return {
        ...state,
        loadingDeleteOrganisationDepartment: false,
        error: action.payload,
      };
    case GET_STAFF_TO_STAFF_MANAGER_LIST:
      return { ...state, loadingStaffToStaffManagerList: true };
    case GET_STAFF_TO_STAFF_MANAGER_LIST_SUCCESS:
      return {
        ...state,
        loadingStaffToStaffManagerList: false,
        staffToStaffManagerList: action.payload,
      };
    case GET_STAFF_TO_STAFF_MANAGER_LIST_FAIL:
      return {
        ...state,
        loadingStaffToStaffManagerList: false,
        error: action.payload,
      };
    case GET_STAFF_TO_STAFF_MANAGER_DATA:
      return { ...state, loadingGetStaffToStaffManagerData: true };
    case GET_STAFF_TO_STAFF_MANAGER_DATA_SUCCESS:
      return {
        ...state,
        loadingGetStaffToStaffManagerData: false,
        singleStaffToStaffManagerData: action.payload,
      };
    case GET_STAFF_TO_STAFF_MANAGER_DATA_FAIL:
      return {
        ...state,
        loadingGetStaffToStaffManagerData: false,
        error: action.payload,
      };
    case CREATE_STAFF_TO_STAFF_MANAGER:
      return { ...state, loadingCreateStaffToStaffManager: true };
    case CREATE_STAFF_TO_STAFF_MANAGER_SUCCESS:
      return {
        ...state,
        loadingCreateStaffToStaffManager: false,
        createStaffToStaffManagerSuccess: action.payload,
      };
    case CREATE_STAFF_TO_STAFF_MANAGER_FAIL:
      return {
        ...state,
        loadingCreateStaffToStaffManager: false,
        error: action.payload,
      };
    case UPDATE_STAFF_TO_STAFF_MANAGER:
      return { ...state, loadingUpdateStaffToStaffManager: true };
    case UPDATE_STAFF_TO_STAFF_MANAGER_SUCCESS:
      return {
        ...state,
        loadingUpdateStaffToStaffManager: false,
        updateStaffToStaffManagerSuccess: action.payload,
      };
    case UPDATE_STAFF_TO_STAFF_MANAGER_FAIL:
      return {
        ...state,
        loadingUpdateStaffToStaffManager: false,
        error: action.payload,
      };
    case DELETE_STAFF_TO_STAFF_MANAGER:
      return { ...state, loadingDeleteStaffToStaffManager: true };
    case DELETE_STAFF_TO_STAFF_MANAGER_SUCCESS:
      return {
        ...state,
        loadingDeleteStaffToStaffManager: false,
        deleteStaffToStaffManagerSuccess: action.payload,
      };
    case DELETE_STAFF_TO_STAFF_MANAGER_FAIL:
      return {
        ...state,
        loadingDeleteStaffToStaffManager: false,
        error: action.payload,
      };
    case GET_STAFF_RECENT_ACTIVITY_LIST:
      return { ...state, loadingStaffRecentActivityList: true };
    case GET_STAFF_RECENT_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        loadingStaffRecentActivityList: false,
        staffRecentActivityList: action.payload,
      };
    case GET_STAFF_RECENT_ACTIVITY_LIST_FAIL:
      return {
        ...state,
        loadingStaffRecentActivityList: false,
        error: action.payload,
      };
    //STAFF_ACTIVITY_LOG_SEARCH — date-ranged log, distinct from the
    //undated staffRecentActivityList above.
    case STAFF_ACTIVITY_LOG_SEARCH:
      return {
        ...state,
        staffActivityLogSearchLoading: true,
        staffActivityLogSearchError: null,
      };
    case STAFF_ACTIVITY_LOG_SEARCH_SUCCESS:
      return {
        ...state,
        staffActivityLogSearch: action.payload,
        staffActivityLogSearchLoading: false,
        staffActivityLogSearchError: null,
      };
    case STAFF_ACTIVITY_LOG_SEARCH_FAILURE:
      return {
        ...state,
        staffActivityLogSearchLoading: false,
        staffActivityLogSearchError: action.payload,
      };
    case SEARCH_STAFF_REAL_TIME:
      return { ...state, loadingSearchStaffRealTime: true };
    case SEARCH_STAFF_REAL_TIME_SUCCESS:
      return {
        ...state,
        loadingSearchStaffRealTime: false,
        searchStaffRealTimeSuccess: action.payload,
      };
    case SEARCH_STAFF_REAL_TIME_FAIL:
      return {
        ...state,
        loadingSearchStaffRealTime: false,
        error: action.payload,
      };
    case GET_STAFF_SKILL_SET_LIST:
      return { ...state, loadingGetStaffSkillSetList: true };
    case GET_STAFF_SKILL_SET_LIST_SUCCESS:
      return {
        ...state,
        loadingGetStaffSkillSetList: false,
        gettingStaffSkillSetList: action.payload,
      };
    case GET_STAFF_SKILL_SET_LIST_FAIL:
      return {
        ...state,
        loadingGetStaffSkillSetList: false,
        error: action.payload,
      };
    case GET_STAFF_SKILL_SET_DATA:
      return { ...state, loadingGetStaffSkillSetData: true };
    case GET_STAFF_SKILL_SET_DATA_SUCCESS:
      return {
        ...state,
        loadingGetStaffSkillSetData: false,
        gettingStaffSkillSetData: action.payload,
      };
    case GET_STAFF_SKILL_SET_DATA_FAIL:
      return {
        ...state,
        loadingGetStaffSkillSetData: false,
        error: action.payload,
      };
    case CREATE_STAFF_SKILL_SET:
      return { ...state, loadingCreateStaffSkillSet: true };
    case CREATE_STAFF_SKILL_SET_SUCCESS:
      return {
        ...state,
        loadingCreateStaffSkillSet: false,
        createStaffSkillSetSuccess: action.payload,
      };
    case CREATE_STAFF_SKILL_SET_FAIL:
      return {
        ...state,
        loadingCreateStaffSkillSet: false,
        error: action.payload,
      };
    case UPDATE_STAFF_SKILL_SET:
      return { ...state, loadingUpdateStaffSkillSet: true };
    case UPDATE_STAFF_SKILL_SET_SUCCESS:
      return {
        ...state,
        loadingUpdateStaffSkillSet: false,
        updateStaffSkillSetSuccess: action.payload,
      };
    case UPDATE_STAFF_SKILL_SET_FAIL:
      return {
        ...state,
        loadingUpdateStaffSkillSet: false,
        error: action.payload,
      };
    case DELETE_STAFF_SKILL_SET:
      return { ...state, loadingDeleteStaffSkillSet: true };
    case DELETE_STAFF_SKILL_SET_SUCCESS:
      return {
        ...state,
        loadingDeleteStaffSkillSet: false,
        deleteStaffSkillSetSuccess: action.payload,
      };
    case DELETE_STAFF_SKILL_SET_FAIL:
      return {
        ...state,
        loadingDeleteStaffSkillSet: false,
        error: action.payload,
      };
    case GET_STAFF_TO_STAFF_SKILL_SET_LIST:
      return { ...state, loadingStaffToStaffSkillSetList: true };
    case GET_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS:
      return {
        ...state,
        loadingStaffToStaffSkillSetList: false,
        staffToStaffSkillSetList: action.payload,
      };
    case GET_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL:
      return {
        ...state,
        loadingStaffToStaffSkillSetList: false,
        error: action.payload,
      };
    case GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST:
      return { ...state, loadingActiveStaffToStaffSkillSetList: true };
    case GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS:
      return {
        ...state,
        loadingActiveStaffToStaffSkillSetList: false,
        activeStaffToStaffSkillSetList: action.payload,
      };
    case GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL:
      return {
        ...state,
        loadingActiveStaffToStaffSkillSetList: false,
        error: action.payload,
      };
    case GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST:
      return { ...state, loadingExpiredStaffToStaffSkillSetList: true };
    case GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST_SUCCESS:
      return {
        ...state,
        loadingExpiredStaffToStaffSkillSetList: false,
        expiredStaffToStaffSkillSetList: action.payload,
      };
    case GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST_FAIL:
      return {
        ...state,
        loadingExpiredStaffToStaffSkillSetList: false,
        error: action.payload,
      };
    case GET_STAFF_TO_STAFF_SKILL_SET_DATA:
      return { ...state, loadingGetStaffToStaffSkillSetData: true };
    case GET_STAFF_TO_STAFF_SKILL_SET_DATA_SUCCESS:
      return {
        ...state,
        loadingGetStaffToStaffSkillSetData: false,
        singleStaffToStaffSkillSetData: action.payload,
      };
    case GET_STAFF_TO_STAFF_SKILL_SET_DATA_FAIL:
      return {
        ...state,
        loadingGetStaffToStaffSkillSetData: false,
        error: action.payload,
      };
    case CREATE_STAFF_TO_STAFF_SKILL_SET:
      return { ...state, loadingCreateStaffToStaffSkillSet: true };
    case CREATE_STAFF_TO_STAFF_SKILL_SET_SUCCESS:
      return {
        ...state,
        loadingCreateStaffToStaffSkillSet: false,
        createStaffToStaffSkillSetSuccess: action.payload,
      };
    case CREATE_STAFF_TO_STAFF_SKILL_SET_FAIL:
      return {
        ...state,
        loadingCreateStaffToStaffSkillSet: false,
        error: action.payload,
      };
    case UPDATE_STAFF_TO_STAFF_SKILL_SET:
      return { ...state, loadingUpdateStaffToStaffSkillSet: true };
    case UPDATE_STAFF_TO_STAFF_SKILL_SET_SUCCESS:
      return {
        ...state,
        loadingUpdateStaffToStaffSkillSet: false,
        updateStaffToStaffSkillSetSuccess: action.payload,
      };
    case UPDATE_STAFF_TO_STAFF_SKILL_SET_FAIL:
      return {
        ...state,
        loadingUpdateStaffToStaffSkillSet: false,
        error: action.payload,
      };
    case DELETE_STAFF_TO_STAFF_SKILL_SET:
      return { ...state, loadingDeleteStaffToStaffSkillSet: true };
    case DELETE_STAFF_TO_STAFF_SKILL_SET_SUCCESS:
      return {
        ...state,
        loadingDeleteStaffToStaffSkillSet: false,
        deleteStaffToStaffSkillSetSuccess: action.payload,
      };
    case DELETE_STAFF_TO_STAFF_SKILL_SET_FAIL:
      return {
        ...state,
        loadingDeleteStaffToStaffSkillSet: false,
        error: action.payload,
      };
    case SEARCH_STAFF_TO_STAFF_SKILL_SET:
      return { ...state, loadingSearchStaffToStaffSkillSet: true };
    case SEARCH_STAFF_TO_STAFF_SKILL_SET_SUCCESS:
      return {
        ...state,
        loadingSearchStaffToStaffSkillSet: false,
        searchStaffToStaffSkillSetSuccess: action.payload,
      };
    case SEARCH_STAFF_TO_STAFF_SKILL_SET_FAIL:
      return {
        ...state,
        loadingSearchStaffToStaffSkillSet: false,
        error: action.payload,
      };
    case SEARCH_STAFF_AVAILABILITY:
      return { ...state, loadingSearchStaffAvailability: true };
    case SEARCH_STAFF_AVAILABILITY_SUCCESS:
      return {
        ...state,
        loadingSearchStaffAvailability: false,
        searchStaffAvailabilitySuccess: action.payload,
      };
    case SEARCH_STAFF_AVAILABILITY_FAIL:
      return {
        ...state,
        loadingSearchStaffAvailability: false,
        error: action.payload,
      };
    case SEARCH_STAFF_GPS_LOCATION_HISTORY:
      return { ...state, loadingSearchStaffGpsLocationHistory: true };
    case SEARCH_STAFF_GPS_LOCATION_HISTORY_SUCCESS:
      return {
        ...state,
        loadingSearchStaffGpsLocationHistory: false,
        searchStaffGpsLocationHistorySuccess: action.payload,
      };
    case SEARCH_STAFF_GPS_LOCATION_HISTORY_FAIL:
      return {
        ...state,
        loadingSearchStaffGpsLocationHistory: false,
        error: action.payload,
      };
    case GET_STAFF_WORKING_SCHEDULE_RECORD_LIST:
      return { ...state, loadingStaffWorkingScheduleRecordList: true };
    case GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_SUCCESS:
      return {
        ...state,
        loadingStaffWorkingScheduleRecordList: false,
        staffWorkingScheduleRecordList: action.payload,
      };
    case GET_STAFF_WORKING_SCHEDULE_RECORD_LIST_FAIL:
      return {
        ...state,
        loadingStaffWorkingScheduleRecordList: false,
        error: action.payload,
      };
    case GET_STAFF_WORKING_SCHEDULE_RECORD_DATA:
      return { ...state, loadingGetStaffWorkingScheduleRecordData: true };
    case GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_SUCCESS:
      return {
        ...state,
        loadingGetStaffWorkingScheduleRecordData: false,
        singleStaffWorkingScheduleRecordData: action.payload,
      };
    case GET_STAFF_WORKING_SCHEDULE_RECORD_DATA_FAIL:
      return {
        ...state,
        loadingGetStaffWorkingScheduleRecordData: false,
        error: action.payload,
      };
    case CREATE_STAFF_WORKING_SCHEDULE_RECORD:
      return { ...state, loadingCreateStaffWorkingScheduleRecord: true };
    case CREATE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS:
      return {
        ...state,
        loadingCreateStaffWorkingScheduleRecord: false,
        createStaffWorkingScheduleRecordSuccess: action.payload,
      };
    case CREATE_STAFF_WORKING_SCHEDULE_RECORD_FAIL:
      return {
        ...state,
        loadingCreateStaffWorkingScheduleRecord: false,
        error: action.payload,
      };
    case UPDATE_STAFF_WORKING_SCHEDULE_RECORD:
      return { ...state, loadingUpdateStaffWorkingScheduleRecord: true };
    case UPDATE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS:
      return {
        ...state,
        loadingUpdateStaffWorkingScheduleRecord: false,
        updateStaffWorkingScheduleRecordSuccess: action.payload,
      };
    case UPDATE_STAFF_WORKING_SCHEDULE_RECORD_FAIL:
      return {
        ...state,
        loadingUpdateStaffWorkingScheduleRecord: false,
        error: action.payload,
      };
    case DELETE_STAFF_WORKING_SCHEDULE_RECORD:
      return { ...state, loadingDeleteStaffWorkingScheduleRecord: true };
    case DELETE_STAFF_WORKING_SCHEDULE_RECORD_SUCCESS:
      return {
        ...state,
        loadingDeleteStaffWorkingScheduleRecord: false,
        deleteStaffWorkingScheduleRecordSuccess: action.payload,
      };
    case DELETE_STAFF_WORKING_SCHEDULE_RECORD_FAIL:
      return {
        ...state,
        loadingDeleteStaffWorkingScheduleRecord: false,
        error: action.payload,
      };
    case GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST:
      return {
        ...state,
        loadingStaffWorkingScheduleRecordAdjustmentList: true,
      };
    case GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_SUCCESS:
      return {
        ...state,
        loadingStaffWorkingScheduleRecordAdjustmentList: false,
        staffWorkingScheduleRecordAdjustmentList: action.payload,
      };
    case GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST_FAIL:
      return {
        ...state,
        loadingStaffWorkingScheduleRecordAdjustmentList: false,
        error: action.payload,
      };
    case GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA:
      return {
        ...state,
        loadingGetStaffWorkingScheduleRecordAdjustmentData: true,
      };
    case GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_SUCCESS:
      return {
        ...state,
        loadingGetStaffWorkingScheduleRecordAdjustmentData: false,
        singleStaffWorkingScheduleRecordAdjustmentData: action.payload,
      };
    case GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA_FAIL:
      return {
        ...state,
        loadingGetStaffWorkingScheduleRecordAdjustmentData: false,
        error: action.payload,
      };
    case CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT:
      return {
        ...state,
        loadingCreateStaffWorkingScheduleRecordAdjustment: true,
      };
    case CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        loadingCreateStaffWorkingScheduleRecordAdjustment: false,
        createStaffWorkingScheduleRecordAdjustmentSuccess: action.payload,
      };
    case CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL:
      return {
        ...state,
        loadingCreateStaffWorkingScheduleRecordAdjustment: false,
        error: action.payload,
      };
    case UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT:
      return {
        ...state,
        loadingUpdateStaffWorkingScheduleRecordAdjustment: true,
      };
    case UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        loadingUpdateStaffWorkingScheduleRecordAdjustment: false,
        updateStaffWorkingScheduleRecordAdjustmentSuccess: action.payload,
      };
    case UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL:
      return {
        ...state,
        loadingUpdateStaffWorkingScheduleRecordAdjustment: false,
        error: action.payload,
      };
    case DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT:
      return {
        ...state,
        loadingDeleteStaffWorkingScheduleRecordAdjustment: true,
      };
    case DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        loadingDeleteStaffWorkingScheduleRecordAdjustment: false,
        deleteStaffWorkingScheduleRecordAdjustmentSuccess: action.payload,
      };
    case DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_FAIL:
      return {
        ...state,
        loadingDeleteStaffWorkingScheduleRecordAdjustment: false,
        error: action.payload,
      };
    case GET_STAFF_WORKING_SCHEDULE_LIST:
      return { ...state, loadingStaffWorkingScheduleList: true };
    case GET_STAFF_WORKING_SCHEDULE_LIST_SUCCESS:
      return {
        ...state,
        loadingStaffWorkingScheduleList: false,
        staffWorkingScheduleList: action.payload,
      };
    case GET_STAFF_WORKING_SCHEDULE_LIST_FAIL:
      return {
        ...state,
        loadingStaffWorkingScheduleList: false,
        error: action.payload,
      };
    case GET_STAFF_WORKING_SCHEDULE_DATA:
      return { ...state, loadingGetStaffWorkingScheduleData: true };
    case GET_STAFF_WORKING_SCHEDULE_DATA_SUCCESS:
      return {
        ...state,
        loadingGetStaffWorkingScheduleData: false,
        singleStaffWorkingScheduleData: action.payload,
      };
    case GET_STAFF_WORKING_SCHEDULE_DATA_FAIL:
      return {
        ...state,
        loadingGetStaffWorkingScheduleData: false,
        error: action.payload,
      };
    case CREATE_STAFF_WORKING_SCHEDULE:
      return { ...state, loadingCreateStaffWorkingSchedule: true };
    case CREATE_STAFF_WORKING_SCHEDULE_SUCCESS:
      return {
        ...state,
        loadingCreateStaffWorkingSchedule: false,
        createStaffWorkingScheduleSuccess: action.payload,
      };
    case CREATE_STAFF_WORKING_SCHEDULE_FAIL:
      return {
        ...state,
        loadingCreateStaffWorkingSchedule: false,
        error: action.payload,
      };
    case UPDATE_STAFF_WORKING_SCHEDULE:
      return { ...state, loadingUpdateStaffWorkingSchedule: true };
    case UPDATE_STAFF_WORKING_SCHEDULE_SUCCESS:
      return {
        ...state,
        loadingUpdateStaffWorkingSchedule: false,
        updateStaffWorkingScheduleSuccess: action.payload,
      };
    case UPDATE_STAFF_WORKING_SCHEDULE_FAIL:
      return {
        ...state,
        loadingUpdateStaffWorkingSchedule: false,
        error: action.payload,
      };
    case DELETE_STAFF_WORKING_SCHEDULE:
      return { ...state, loadingDeleteStaffWorkingSchedule: true };
    case DELETE_STAFF_WORKING_SCHEDULE_SUCCESS:
      return {
        ...state,
        loadingDeleteStaffWorkingSchedule: false,
        deleteStaffWorkingScheduleSuccess: action.payload,
      };
    case DELETE_STAFF_WORKING_SCHEDULE_FAIL:
      return {
        ...state,
        loadingDeleteStaffWorkingSchedule: false,
        error: action.payload,
      };
    //SEARCH_STAFF_WORKING_SCHEDULE
    case SEARCH_STAFF_WORKING_SCHEDULE:
      return { ...state, loadingSearchStaffWorkingSchedule: true };
    case SEARCH_STAFF_WORKING_SCHEDULE_SUCCESS:
      return {
        ...state,
        loadingSearchStaffWorkingSchedule: false,
        searchStaffWorkingScheduleSuccess: action.payload,
      };
    case SEARCH_STAFF_WORKING_SCHEDULE_FAIL:
      return {
        ...state,
        loadingSearchStaffWorkingSchedule: false,
        error: action.payload,
      };
    //SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE (isolated channel)
    case SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE:
      return { ...state, loadingSearchStaffWorkingScheduleForClone: true };
    case SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE_SUCCESS:
      return {
        ...state,
        loadingSearchStaffWorkingScheduleForClone: false,
        searchStaffWorkingScheduleForCloneSuccess: action.payload,
      };
    case SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE_FAIL:
      return {
        ...state,
        loadingSearchStaffWorkingScheduleForClone: false,
        error: action.payload,
      };
    //CALCULATE_STAFF_WORKING_SCHEDULE
    case CALCULATE_STAFF_WORKING_SCHEDULE:
      return { ...state, loadingCalculateStaffWorkingSchedule: true };
    case CALCULATE_STAFF_WORKING_SCHEDULE_SUCCESS:
      return {
        ...state,
        loadingCalculateStaffWorkingSchedule: false,
        calculateStaffWorkingScheduleSuccess: action.payload,
      };
    case CALCULATE_STAFF_WORKING_SCHEDULE_FAIL:
      return {
        ...state,
        loadingCalculateStaffWorkingSchedule: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Staff;
